export default "__VITE_ASSET__776a0bcc__"